/**
 * Translator — namespaced Vuex store module.
 *
 * Migrated from the standalone efficient-vineyard-translator plugin.
 * The plugin's original `new Vuex.Store(...)` becomes a namespaced
 * module so the original actions/mutations carry over essentially
 * verbatim — inside a namespaced module, an action's `state` /
 * `commit` / `dispatch` are already scoped to the module.
 *
 * Home.vue registers this module on entry and unregisters it on
 * leave, so each visit starts from clean state.
 */
import actions from './actions.js'
import mutations from './mutations.js'

export default {
  namespaced: true,
  state: () => ({
    alert: {
      active: false,
      message: 'This is a basic alert',
      level: 'alert-info'
    },
    breadcrumbs: [
      { id: 'root', name: 'Root' }
    ],
    correlation: false,
    datasets: [],
    dataset: {},
    datasetGeoJson: {},
    datasetHeader: false,
    datasetLoading: false,
    farm: {},
    folders: [],
    folder: { id: 'root', name: 'Root' },
    mapObject: {},
    mode: 'pick',
    post: { name: 'Translation' },
    posting: false,
    runningTranslation: false,
    samplesDataset: {},
    samplesDatasetGeoJson: {},
    samplesDatasetHeader: false,
    samplesDatasetLoading: false,
    spinner: false,
    slopeIntercept: false,
    translationGeoJson: {}
  }),
  actions,
  mutations
}
